// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__Wkd4-","videoPlayer":"VideoHero_videoPlayer__qbAeu","content":"VideoHero_content__om7be"};